
<div   style="background-image: url('./assets/Img/loginfondo.jpg');" fxLayout = "row" fxLayoutAlign="center center" class= "containers">

    <app-login (outputLogin)= "setCredentials($event)"></app-login> 
</div>
